import React, { useEffect, useRef, useState } from "react";
import { fetchApi } from "../../config";

export default function AboutStats() {
    const [counts, setCounts] = useState([0, 0, 0, 0]);
    const [targets, setTargets] = useState([0, 0, 0, 0]);
    const sectionRef = useRef(null);

    // Fetch dynamic stats from API
    useEffect(() => {
        let active = true;

        async function loadStats() {
            try {
                const res = await fetchApi("get_counters_info.php");

                if (!active) return;

                if (res && Array.isArray(res.Info) && res.Info.length > 0) {
                    const info = res.Info[0];

                    setTargets([
                        Number(info.years_building) || 0,
                        Number(info.projects_shipped) || 0,
                        Number(info.clients_worldwide) || 0,
                        Number(info.countries_served) || 0,
                    ]);
                }
            } catch (err) {
                // Keep counters at 0 if API fails
            }
        }

        loadStats();

        return () => {
            active = false;
        };
    }, []);

    // Fetch dynamic stats from API
    useEffect(() => {
        let active = true;

        async function loadStats() {
            try {
                const res = await fetchApi("get_counters_info.php");

                if (!active) return;

                if (res && Array.isArray(res.Info) && res.Info.length > 0) {
                    const info = res.Info[0];

                    setTargets([
                        Number(info.years_building) || 0,
                        Number(info.projects_shipped) || 0,
                        Number(info.clients_worldwide) || 0,
                        Number(info.countries_served) || 0,
                    ]);
                }
            } catch (err) {
                // Keep counters at 0 if API fails
            }
        }

        loadStats();

        return () => {
            active = false;
        };
    }, []);

    // Animate counters when section enters viewport
    useEffect(() => {
        const node = sectionRef.current;
        if (!node || targets.every((target) => target === 0)) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (!entries[0]?.isIntersecting) return;

                const duration = 1400;
                const startTime = performance.now();

                const step = (time) => {
                    const progress = Math.min(
                        (time - startTime) / duration,
                        1
                    );

                    const eased = 1 - Math.pow(1 - progress, 3);

                    setCounts(
                        targets.map((target) =>
                            Math.round(target * eased)
                        )
                    );

                    if (progress < 1) {
                        requestAnimationFrame(step);
                    } else {
                        setCounts(targets);
                    }
                };

                requestAnimationFrame(step);
                observer.disconnect();
            },
            { threshold: 0.35 }
        );

        observer.observe(node);

        return () => observer.disconnect();
    }, [targets]);

    return (
        <section className="container" ref={sectionRef}>
            <div className="stats">
                <div>
                    <div className="n">
                        <span className="count">
                            {counts[0]}
                        </span>
                        <span>+</span>
                    </div>
                    <div className="l">years building</div>
                </div>

                <div>
                    <div className="n">
                        <span className="count">
                            {counts[1]}
                        </span>
                        <span>+</span>
                    </div>
                    <div className="l">projects shipped</div>
                </div>

                <div>
                    <div className="n">
                        <span className="count">
                            {counts[2]}
                        </span>
                        <span>+</span>
                    </div>
                    <div className="l">clients worldwide</div>
                </div>

                <div>
                    <div className="n">
                        <span className="count">
                            {counts[3]}
                        </span>
                    </div>
                    <div className="l">countries served</div>
                </div>
            </div>
        </section>
    );
}
